/**
 * @class Column Definition Properties
 */
export class ColumnDefintion {
  constructor(
    id?: number,
    displayName?: string,
    scratchPadName?: string,
    dataPropertyName?: string,
    type?: number,
    dataFormat?: number,
    isSelected?: boolean
  ) {
    this.Id = id;
    this.DisplayName = displayName;
    this.DataPropertyName = dataPropertyName;
    this.ScratchPadName = scratchPadName;
    this.Type = type;
    this.IsSelected = isSelected;
    this.DataFormat = dataFormat;
  }
  Id?: number;
  DisplayName?: string;
  ScratchPadName?: string;
  DataPropertyName?: string;
  Type?: number;
  IsSelected?: boolean;
  DataFormat?: number;
  TextColor?: string;
}
/**
 * @class Selected Column Definition Properties - INI properties
 */
export class TblColumnDefinitions {
  id?: number;
  empNum?: string;
  version?: string;
  columnDefinitionJsonString?: string;

  constructor(
    id?: number,
    version?: string,
    colDefs?: string,
    empNum?: string
  ) {
    this.id = id;
    this.empNum = empNum;
    this.version = version;
    this.columnDefinitionJsonString = colDefs;
  }
}

/**
 * @class Selected vacation Column Definition Properties - INI properties
 */
export class TblVacColumnDefinitions {
  id?: number;
  empNum?: string;
  version?: string;
  columnDefinitionJsonString?: string;

  constructor(
    id?: number,
    version?: string,
    colDefs?: string,
    empNum?: string
  ) {
    this.id = id;
    this.empNum = empNum;
    this.version = version;
    this.columnDefinitionJsonString = colDefs;
  }
}
/**
 * @class Json Values(columnDefinitionJsonString) for storing slected line informations
 */
export class DataColumn {
  Id?: number;
  Order?: number;
  isVac?: boolean;
  constructor(id?: number, order?: number, isVac?: boolean) {
    this.Id = id;
    this.Order = order;
    this.isVac = isVac;
  }
}
